"use client";

import { HeroUIProvider } from "@heroui/system";
import { useRouter } from "@/i18n/routing";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ThemeProviderProps } from "next-themes/dist/types";
import { ModalProvider } from "@/components/modal-context";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect /*useMemo, useState*/ } from "react";
import { io, Socket } from "socket.io-client";
import { GetUserDetailAction } from "@/lib/actions";
import { LivechatProvider } from "@/components/livechat-context";
import { OTPProvider } from "@/components/use-otp";
import Refresher from "@/components/Refresher";
import { RefreshProvider } from "@/components/useRefresh";
import { SocketIOProvider } from "@/components/socketio-context";
export interface ProvidersProps {
  children: React.ReactNode;
  themeProps?: ThemeProviderProps;
  token?: string;
}

export function Providers({ children, themeProps, token }: ProvidersProps) {
  const router = useRouter();
  return (
    <SocketIOProvider accessToken={token}>
      <ToastContainer
        className={"pointer-events-auto !absolute"}
        autoClose={3000}
        position="bottom-right"
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        draggable
        theme="dark"
        transition={Slide}
        limit={1}
      />
      <HeroUIProvider navigate={router.push}>
        <ModalProvider>
          <NextThemesProvider {...themeProps}>
            <OTPProvider>
              <LivechatProvider>
                <RefreshProvider>
                  <Refresher>{children}</Refresher>
                </RefreshProvider>
              </LivechatProvider>
            </OTPProvider>
          </NextThemesProvider>
        </ModalProvider>
      </HeroUIProvider>
    </SocketIOProvider>
  );
}
